import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Bot, Send } from 'lucide-react';
import './ChatbotWidget.css';
import ReactMarkdown from 'react-markdown';

const ChatbotWidget = ({ coffeeShopId }) => {
  const [input, setInput] = useState('');
  const [chat, setChat] = useState([]);

  useEffect(() => {
    console.log('✅ Explicitly received coffeeShopId:', coffeeShopId);
  }, [coffeeShopId]);

  const sendMessage = async () => {
    if (!coffeeShopId || !input.trim()) {
      console.warn('⚠️ Missing coffeeShopId or empty input:', coffeeShopId);
      return;
    }

    setChat(prev => [...prev, { sender: 'User', message: input }]);

    try {
      const response = await axios.post('https://us-central1-loyalitysystem-d564d.cloudfunctions.net/chatbot', {
        message: input,
        coffeeShopId,
      });
    
      console.log('✅ API Response:', response.data);
      setChat(prev => [...prev, { sender: 'AI', message: response.data.reply }]); // ✅ safe here
    } catch (error) {
      setChat(prev => [...prev, { sender: 'AI', message: 'Error connecting to AI.' }]);
      console.error('❌ Axios Error:', error);
    }

    setInput('');
  };

  return (
    <div className="chatbot-container">
      <div className="chat-header">
        <Bot size={24} />
        <span>LoyalTap AI Chat</span>
      </div>

      <div className="chat-window">
        {chat.map((msg, idx) => (
          <div key={idx} className={`message ${msg.sender === 'User' ? 'user' : 'ai'}`}>
            <div className="message-content">
  {msg.sender === 'AI' ? (
    <ReactMarkdown>{msg.message}</ReactMarkdown>
  ) : (
    msg.message
  )}
</div>
          </div>
        ))}
      </div>

      <div className="chat-input-area">
        <input
          type="text"
          value={input}
          placeholder="Talk to LoyalTap AI..."
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && sendMessage()}
        />
        <button onClick={sendMessage}>
          <Send size={20} />
        </button>
      </div>
    </div>
  );
};

export default ChatbotWidget;
